import Cookies from 'js-cookie';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import {
    Grid,
    Card,
    Button,
    Checkbox,
    FormGroup,
    TextField,
    Typography,
    IconButton,
    CardContent,
    FormControl,
    InputAdornment,
    FormControlLabel,
} from '@material-ui/core';

import './styles.css';
import api from '../../services/api';
import logo from '../../assets/logo.png';

export default function Login() {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const auth = Cookies.get("is_authenticated");
    if (auth === "true") {
        history.push("/dashboard");
    }

    const [manter_conectado, setManterConectado] = useState(false);
    const [verSenhaAtual, setVerSenhaAtual] = useState(false)


    async function loginSubmit(event) {
        event.preventDefault();
        await api.post("/sessions",
            {
                email: email,
                senha: senha,
                access: "ui"
            })
            .then((response) => {
                localStorage.setItem("user", response.data._id);
                localStorage.setItem("email", email);
                localStorage.setItem("avatar", response.data.avatar);
                localStorage.setItem("nome", response.data.nome);
                Cookies.set("auth_token_ui", response.data.auth_token_ui, { expires: 100 });

                // verifica se o usuário esta ativo ou inativo
                if (response.data.status === "ativo") {
                    // verifica se o usuário tem acesso a interface administrativa
                    if (response.data.admin === "Sim") {
                        if (manter_conectado === true) {
                            console.log("Usuário autenticado por 100 dias");
                            Cookies.set("is_authenticated", "true", { expires: 100 });
                        } else {
                            console.log("autenticação provisória, 1 dia");
                            Cookies.set("is_authenticated", "true", { expires: 1 });
                        }
                        history.push("/dashboard");
                    }
                    else {
                        enqueueSnackbar("Esse usuário não tem acesso a interface administrativa", { variant: 'info' })
                    }
                }
                else {
                    enqueueSnackbar("Usuário inativo", { variant: 'info' })
                }
            })
            .catch((error) => {
                if (!error.response) {
                    enqueueSnackbar("Servidor não conectado!", { variant: 'error' })
                }
                else if (error.response.status === 404) {
                    enqueueSnackbar("Usuário ou senha incorretos", { variant: 'error' })
                }
            })
    }

    return (
        <div className="background">
            <Grid container spacing={0} alignItems="center" justify="center" direction="column" className="full-grid">
                <Card raised className="login-card">
                    <CardContent>
                        <form onSubmit={loginSubmit}>
                            <Typography gutterBottom>
                                <img className="login" src={logo} alt="PAEweb" width="180" />
                            </Typography>
                            <FormGroup>
                                <FormControl margin="dense" fullWidth={true}>
                                    <TextField
                                        id="email"
                                        type="email"
                                        placeholder="Seu email"
                                        value={email}
                                        variant="outlined"
                                        onChange={(event) => setEmail(event.target.value)}
                                    />
                                </FormControl>
                                <FormControl margin="dense" fullWidth={true}>
                                    <TextField
                                        id="password"
                                        type={verSenhaAtual ? "text" : "password"}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        tabIndex="-1"
                                                        onClick={() => setVerSenhaAtual(!verSenhaAtual)}
                                                        onMouseDown={(event) => event.preventDefault()}
                                                    >
                                                        {verSenhaAtual ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        fullWidth
                                        label="Informe a senha atual"
                                        variant="outlined"
                                        onChange={(event) => setSenha(event.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                            <FormGroup aria-label="position" row>
                                <FormControlLabel
                                    control={<Checkbox color="primary" onChange={(e) => setManterConectado(e.target.checked)} />}
                                    label="Manter-se conectado"
                                />
                                <Typography
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        marginInlineStart: "auto",
                                    }}
                                    component="label"
                                    display="inline"
                                >
                                    <Link to="/recuperar-a-senha">
                                        <small>Esqueceu sua senha?</small>
                                    </Link>
                                </Typography>
                            </FormGroup>
                            <br />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth={true}
                                size="large"
                                className="btn-login"
                            // disabled={(
                            //     email === "" ||
                            //     senha === "")
                            //     ? true : false}
                            >Entrar</Button>
                        </form>
                        <br />
                    </CardContent>
                </Card>
                {/* <footer>
                    <a href="/">
                        <img src={logo} alt="Locus" title="desenvolvido por Locus tecnologia" />
                    </a>
                </footer> */}
            </Grid>
        </div>
    );
}
